import { getAccordionAnchorById } from "@toolkit/Framework/Store/Toolkit/Components/Accordion/AccordionSelectors";
import { createHandlerChainRunner, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

export interface RemoveAccordionAnchorParameter {
    id: string;
}

type HandlerType = Handler<RemoveAccordionAnchorParameter>;

export const DispatchRemoveAccordionAnchor: HandlerType = props => {
    const anchor = getAccordionAnchorById(props.getState(), props.parameter.id);

    if (anchor) {
        props.dispatch({
            type: "Toolkit/Components/Accordion/RemoveAccordionAnchor",
            id: props.parameter.id,
        });
    }
};

export const chain = [DispatchRemoveAccordionAnchor];

const removeAccordionAnchor = createHandlerChainRunner(chain, "RemoveAccordionAnchor");

export default removeAccordionAnchor;
